import { render } from "./DestinationChooser.vue?vue&type=template&id=7149d9ae&scoped=true&ts=true&lang=pug"
import script from "./DestinationChooser.vue?vue&type=script&lang=ts"
export * from "./DestinationChooser.vue?vue&type=script&lang=ts"

import "./DestinationChooser.vue?vue&type=style&index=0&id=7149d9ae&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./DestinationChooser.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/views/destinationChooser.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FDestinationChooser.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7149d9ae"]])

export default __exports__